import React, { useState } from 'react';
import { Table, Button, Card, Space, Modal, Form, Input, Select, Tag, Switch, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

const ProxyManagement = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  // Mock data for proxy pools
  const data = [
    {
      key: '1',
      name: 'US Premium Pool',
      type: 'HTTP',
      host: 'proxy-us.example.com',
      port: 8080,
      authType: 'User/Pass',
      status: 'Active',
      provider: 'Self-Hosted',
    },
    {
      key: '2',
      name: 'Bright Data Residential',
      type: 'SOCKS5',
      host: 'brd.superproxy.io',
      port: 22225,
      authType: 'User/Pass',
      status: 'Active',
      provider: 'Bright Data',
    },
    {
      key: '3',
      name: 'Internal Test Proxy',
      type: 'HTTP',
      host: '10.0.0.50',
      port: 3128,
      authType: 'None',
      status: 'Inactive',
      provider: 'Self-Hosted',
    },
  ];

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => <Tag color={type === 'SOCKS5' ? 'blue' : 'green'}>{type}</Tag>,
    },
    {
      title: 'Host',
      dataIndex: 'host',
      key: 'host',
    },
    {
      title: 'Port',
      dataIndex: 'port',
      key: 'port',
    },
    {
      title: 'Provider',
      dataIndex: 'provider',
      key: 'provider',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'Active' ? 'success' : 'default'}>{status}</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" icon={<EditOutlined />}>Edit</Button>
          <Button type="link" danger icon={<DeleteOutlined />}>Delete</Button>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.validateFields().then(values => {
      console.log('Received values of form: ', values);
      setIsModalVisible(false);
      message.success('Proxy configuration saved successfully');
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  return (
    <Card 
      title="Network Proxy Management" 
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Add Proxy Pool
        </Button>
      }
      style={{ marginTop: 16 }}
    >
      <Table columns={columns} dataSource={data} pagination={false} />

      <Modal 
        title="Add/Edit Proxy Configuration" 
        visible={isModalVisible} 
        onOk={handleOk} 
        onCancel={() => setIsModalVisible(false)}
      >
        <Form form={form} layout="vertical" name="proxy_form">
          <Form.Item name="name" label="Proxy Name" rules={[{ required: true }]}>
            <Input placeholder="e.g., US Residential Pool" />
          </Form.Item>
          <Form.Item name="type" label="Protocol Type" initialValue="HTTP">
            <Select>
              <Option value="HTTP">HTTP</Option>
              <Option value="HTTPS">HTTPS</Option>
              <Option value="SOCKS5">SOCKS5</Option>
            </Select>
          </Form.Item>
          <Form.Item name="provider" label="Provider" initialValue="Self-Hosted">
            <Select>
              <Option value="Self-Hosted">Self-Hosted / Custom</Option>
              <Option value="Bright Data">Bright Data</Option>
              <Option value="Oxylabs">Oxylabs</Option>
              <Option value="Smartproxy">Smartproxy</Option>
            </Select>
          </Form.Item>
          <Form.Item name="host" label="Host / IP" rules={[{ required: true }]}>
            <Input placeholder="192.168.1.1 or proxy.example.com" />
          </Form.Item>
          <Form.Item name="port" label="Port" rules={[{ required: true }]}>
            <Input type="number" placeholder="8080" />
          </Form.Item>
          <Form.Item name="username" label="Username (Optional)">
            <Input />
          </Form.Item>
          <Form.Item name="password" label="Password (Optional)">
            <Input.Password />
          </Form.Item>
          <Form.Item name="status" label="Status" valuePropName="checked" initialValue={true}>
            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default ProxyManagement;
